import * as React from 'react'
import {FC} from 'react'
import {Form, Radio} from 'antd'
import {buttonsStyle, groupRadioStyle} from '../../constants/layout'
import {OWNER_IS_LEGAL_ENTITY} from '../../constants/fields'

const {Item} = Form
const {Group, Button} = Radio

interface OwnerPropsInterface {
    onChange?: (value) => void
}

const Owner: FC<OwnerPropsInterface> = ({onChange}) => {
    return (
        <Item {...OWNER_IS_LEGAL_ENTITY} className={'calc__radio-group'}>
            <Group size='large' style={groupRadioStyle} onChange={onChange}>
                <Button style={buttonsStyle} value={false}>
                    Физ. лицо
                </Button>
                <Button style={buttonsStyle} value={true}>
                    Юр. лицо
                </Button>
            </Group>
        </Item>
    )
}

Owner.defaultProps = {
    onChange: value => {},
}

export default Owner
